<template>
    <div class="accordion">
        <button @click="toggle" class="accordion__btn">
            <slot name="title" />
            <span class="direction no_print">{{directionMessage[direction]}} <i :class="`uk-icon-chevron-${direction}`"></i></span>
        </button>
        <animate-wrapper :isVisible="direction === 'up'" :targetHeight="contentHeight">
            <div ref="contentWrapper" class="accordion__content">
                <slot name="content" />
            </div>
        </animate-wrapper>
    </div>
</template>

<script>
import animateWrapper from '@/components/ui/appAccordion/animateWrapper.vue.js'

export default {
    components: { animateWrapper },
    data: () => ({
        direction: 'down',
        directionMessage: {
            down: 'Развернуть',
            up: 'Свернуть'
        },
        contentHeight: 0

    }),
    methods: {
        toggle() {
            this.contentHeight = this.$refs.contentWrapper.clientHeight
            this.direction = this.direction === 'down' ? 'up' : 'down'
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.contentHeight = this.$refs.contentWrapper?.clientHeight || 500
        })
    }
}
</script>

<style lang="sass" scoped>
.accordion
    p, span
        font: inherit !important
        margin: 0
        padding: 0
    &__btn
        font-family: Helvetica, Arial, Tahoma, sans-serif
        background: none
        border: none
        cursor: pointer
        display: flex
        align-items: center
        flex-wrap: wrap
        gap: 5px
        color: #444
        font-size: 16px !important
        span.direction
            color: #a0a0a0
            font-size: 11px !important
        &:hover
            color: #074c92
            span, p
                color: #074c92 !important
            span.direction
                color: #6d6c6c !important
    &__content
        margin-top: 7px
        overflow: hidden
        transition: max-height 1.5s
        height: auto
</style>